import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ICustomersList {
  customerId: string;
  customerName: string;
}

interface CustomersState {
  customersList: ICustomersList[];
}
const initialState: CustomersState = {
  customersList: [],
};
const CustomersList = createSlice({
  name: "CutomersList",
  initialState,
  reducers: {
    setCustomersList: (state: any, action: PayloadAction<ICustomersList[]>) => {
      state.customersList = action.payload;
    },
  },
});

export const { setCustomersList } = CustomersList.actions;
export default CustomersList;
